/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

/* jshint node: true */

require('./bootstrap');
require('./utils'); //our utils and helpers
import ApiAuthMixin from './mixins/ApiAuthMixin.js';

/*try {
    window.moment = require('moment');
    window.moment.locale('en');
} catch (e) {
    alert(e);
}*/

window.Vue = require('vue');
import Vue from 'vue';

// Import i18n for multi-language support
import { $t, i18n } from './utils/i18n';

if (!global._babelPolyfill) { // only load babel polyfill if it hasn't been loaded already (some components such as facebook login load it)
    require("babel-polyfill");
}

//Packages
import * as Sentry from '@sentry/browser';

import BootstrapVue from 'bootstrap-vue';
Vue.use(BootstrapVue);

import 'cleave.js';

import Countdown from 'vuejs-countdown';

import SocialSharing from 'vue-social-sharing';
Vue.use(SocialSharing);

import ToggleButton from 'vue-js-toggle-button';
Vue.use(ToggleButton);

import 'url-search-params-polyfill';

import VeeValidate from 'vee-validate';
Vue.use(VeeValidate, {
    errorBagName: 'vErrors', //Set this to avoid VFG conflicts
    fieldsBagName: 'vFields', //important to name this something else
});

import VueClipboard from 'vue-clipboard2';
VueClipboard.config.autoSetContainer = true;
Vue.use(VueClipboard);

import VueCollapse from 'vue2-collapse';
Vue.use(VueCollapse);

import VueFormGenerator from "vue-form-generator";
import "vue-form-generator/dist/vfg.css"; // optional full css additions
Vue.use(VueFormGenerator);

import VueQriously from 'vue-qriously';
Vue.use(VueQriously);

import VueScrollTo from 'vue-scrollto';
Vue.use(VueScrollTo);

import VueTheMask from 'vue-the-mask';
Vue.use(VueTheMask);

//@TODO REFACTOR THESE COMPONENTS
import ClubSelect from './components/AAA_TO_REFACTOR/ClubSelect';
import LoyaltySchemeRedeemer from "./components/RedeemedLoyaltySchemePoints/Form/Add.vue";
import OccasionSearch from "./components/AAA_TO_REFACTOR/OccasionSearch.vue";
import OccasionTypeFilter from "./components/AAA_TO_REFACTOR/OccasionTypeFilter.vue";
import ParticipantEditForm from "./components/AAA_TO_REFACTOR/ParticipantEditForm.vue";
import UserMoveParticipantModal from "./components/Participants/Form/UserMoveParticipantModal.vue";
import QuantityPicker from "./components/AAA_TO_REFACTOR/QuantityPicker.vue";
import Signup from './components/AAA_TO_REFACTOR/Signup.vue';
import SkuPicker from './components/AAA_TO_REFACTOR/SkuPicker.vue';

import ThemedBootstrapCard from "./components/AAA_TO_REFACTOR/Bootstrap/Bootstrap/Card/ThemedBootstrapCard";
Vue.component('ThemedBootstrapCard', ThemedBootstrapCard);

import ThemedBootstrapCardBody from "./components/AAA_TO_REFACTOR/Bootstrap/Bootstrap/Card/ThemedBootstrapCardBody";
Vue.component('ThemedBootstrapCardBody', ThemedBootstrapCardBody);

import ThemedBootstrapCardFooter from "./components/AAA_TO_REFACTOR/Bootstrap/Bootstrap/Card/ThemedBootstrapCardFooter";
Vue.component('ThemedBootstrapCardFooter', ThemedBootstrapCardFooter);

import ThemedBootstrapCardHeader from "./components/AAA_TO_REFACTOR/Bootstrap/Bootstrap/Card/ThemedBootstrapCardHeader";
Vue.component('ThemedBootstrapCardHeader', ThemedBootstrapCardHeader);

//Ai FAQ
import FaqAgent from "./components/AiAgents/FaqAgent/FaqAgent.vue";
import MessengerContainer from "./components/Messenger/MessengerContainer.vue";

//Checkout
import CheckoutComplete from './components/Checkout/CheckoutComplete.vue';

//Credits
import Credit from "./components/Credits/Form/Default.vue";
import CreditOutwardFacingStatusLabel from './components/Credits/OutwardFacingStatusLabel.vue';

//Donations
import DonationGroup from "./components/Donations/Form/Bulk.vue";

//FAQs
import FaqsListWithSearch from "./components/Faqs/ListWithSearch.vue";

//JustGivingCharities
import JustGivingSetup from './components/JustGivingCharities/Setup.vue';

//Members
import RegistrationCategoryMemberEnterButton from './components/Members/Utilities/Buttons/EnterRegistrationCategoryButton';

//Orders
import OrdersTableContainer from "./components/Orders/TableContainer.vue";//SHOULD THIS BE IN HERE, OR JUST IN APP_ADMIN?
import Order from './components/Orders/Form/Default.vue';

import OrderStatusLabel from "./components/Orders/OrderStatusLabel";
Vue.component('OrderStatusLabel', OrderStatusLabel);

//Participants
import CompleteParticipantTicket from './components/Participants/CompleteTicket.vue';
import BulkParticipant from './components/Participants/Form/Bulk.vue';
import BulkTeamTickets from "./components/Participants/Form/BulkTeamTickets.vue";
import FriendInviter from './components/Participants/FriendInviter.vue';
import ParticipantsIframeTable from './components/Participants/IframeTable';
import ParticipantsIframeTableContainer from './components/Participants/IframeTableContainer';
import InviteToTeam from "./components/Participants/InviteToTeam";
import PrePayInviter from './components/Participants/PrePayInviter.vue';
import SaveParticipantProfileToggleButton from './components/Participants/SaveParticipantProfileToggleButton.vue';
import ParticipantsTableContainer from "./components/Participants/TableContainer.vue";//SHOULD THIS BE IN HERE, OR JUST IN APP_ADMIN?
import SendReminderButton from "./components/Participants/Utilities/Buttons/SendPrepayReminderButton.vue";
import TransferEntryModalForm from "./components/Participants/Form/TransferEntryModalForm.vue";

//Products
import Product from './components/Products/Form/Default.vue';
import ProductImageGallery from './components/Products/ImageGallery.vue';

//RegistrationCategories
import TicketList from "./components/RegistrationCategories/Tickets/List";

//RegistrationCategorySeries
import RegistrationCategorySeriesCard from './components/RegistrationCategorySeries/Card.vue';

//Results
import AddResult from './components/Results/Form/Add.vue';

//Subscribers
import Subscribe from "./components/Subscribers/Form/Default";

//Teams
import TeamStatusLabel from "./components/Teams/Utilities/Lables/TeamStatusLabel.vue";

//Users
import LoginOrGhost from './components/Users/LoginOrGhost';
import LoginOrSignup from './components/Users/LoginOrSignup/LoginOrSignup.vue';

//Common
import LanguageSwitcher from './components/Common/LanguageSwitcher.vue';

//ParticipantDocumentUploads
import ParticipantDocumentUploads from "./components/Participants/ParticipantDocumentUploads.vue";

//Utility
import RenderJson from './components/Utility/RenderJson';
import CopyToClipboard from "./components/Utility/Buttons/CopyToClipboard.vue";
import MoneyInput from "./components/Utility/Forms/InputFields/MoneyInput.vue";
import SimpleBoolean from "./components/Utility/InlineTemplates/SimpleBoolean.vue";
import ValueStorage from "./components/Utility/InlineTemplates/ValueStorage.vue";

import ApiToggleButton from "./components/Utility/Buttons/ApiToggleButton.vue";
Vue.component('ApiToggleButton', ApiToggleButton);

import CountryInput from "./components/Utility/Forms/InputFields/CountryInput.vue";
Vue.component('CountryInput', CountryInput);

import DateField from "./components/Utility/Forms/InputFields/DateField.vue";
Vue.component('DateField', DateField);

import PostCodeInput from "./components/Utility/Forms/InputFields/PostCodeInput.vue";
Vue.component('PostCodeInput', PostCodeInput);

import PaymentStatusLabel from "./components/Utility/Labels/PaymentStatusLabel";
Vue.component('PaymentStatusLabel', PaymentStatusLabel);

import PersonalBestLabel from "./components/Utility/Labels/PersonalBestLabel";
Vue.component('PersonalBestLabel', PersonalBestLabel);

import LazyImageGallery from "./components/Common/LazyImageGallery.vue";
Vue.component('LazyImageGallery', LazyImageGallery);

import ReportTable from '../../plugins/Reports/Assets/components/ReportTable.vue';
Vue.component('ReportTable', ReportTable);

import LazySponsorShowcase from "./components/Sponsors/LazySponsorShowcase.vue";
Vue.component('LazySponsorShowcase', LazySponsorShowcase);

// Setup i18n for Vue components
Vue.prototype.$t = $t;

new Vue({
    el: '#root',

    mixins: [ApiAuthMixin],

    components: {
        AddResult,
        FaqAgent,
        BulkParticipant,
        BulkTeamTickets,
        CheckoutComplete,
        ClubSelect,
        CompleteParticipantTicket,
        MessengerContainer,
        CopyToClipboard,
        Countdown,
        Credit,
        CreditOutwardFacingStatusLabel,
        DonationGroup,
        FaqsListWithSearch,
        FriendInviter,
        InviteToTeam,
        JustGivingSetup,
        LanguageSwitcher,
        LoginOrGhost,
        LoginOrSignup,
        LoyaltySchemeRedeemer,
        MoneyInput,
        OccasionSearch,
        OccasionTypeFilter,
        Order,
        OrdersTableContainer,
        ParticipantEditForm,
        UserMoveParticipantModal,
        ParticipantsIframeTable,
        ParticipantsIframeTableContainer,
        ParticipantsTableContainer,
        PrePayInviter,
        SaveParticipantProfileToggleButton,
        Product,
        ProductImageGallery,
        RegistrationCategoryMemberEnterButton,
        RegistrationCategorySeriesCard,
        RenderJson,
        QuantityPicker,
        SendReminderButton,
        Signup,
        SimpleBoolean,
        SkuPicker,
        Subscribe,
        TeamStatusLabel,
        TicketList,
        TransferEntryModalForm,
        ValueStorage,
        ParticipantDocumentUploads,
    },
});



// WEBPACK FOOTER //
// ./src/Assets/app.js